import React from 'react';
import ExpandedListTab from '../ExpandedListTab';
import UploadButton from '../buttons/UploadButton';
import Constants from '../../utils/Constants';
import { Privileged } from '../../hocs/withPrivileges';
import Privileges from '../../utils/Privileges';

function BulkUploadDetailTab() {
    const responseReceiverComponent = (responseData, responseFileName) => {
        // Trigger download
        if (responseFileName) {
            const url = window.URL.createObjectURL(new Blob([responseData]));
            return (
                <div style={{  padding: '10px', justifyContent: 'center', alignItems: 'center' }}>
                    <a
                        href={url}
                        download={responseFileName}
                        style={{
                            display: 'inline-block',
                            padding: '8px 16px',
                            backgroundColor: '#ff0000',
                            color: '#ffffff',
                            textDecoration: 'none',
                            borderRadius: '4px',
                            fontWeight: 500,
                        }}
                    >
                        Download {responseFileName}
                    </a>
                </div>
            );
        }
    };
    return (
        <ExpandedListTab className="settings-detail-tab" scrollToTop>
            <div className="bulk-upload-buttons">
                <Privileged sufficientPrivileges={[Privileges.SETTINGS_EDIT]}>
                    <UploadButton
                        label="Upload members"
                        className="button-bordered"
                        uploadPath={Constants.UPLOAD_MEMBERS_PATH}
                        responseComp={responseReceiverComponent}
                        accept=".csv"
                        multiple={false}
                    />
                    &nbsp;
                    <UploadButton
                        label="Upload users"
                        className="button-bordered"
                        uploadPath={Constants.UPLOAD_USERS_PATH}
                        responseComp={responseReceiverComponent}
                        accept=".csv"
                    />
                </Privileged>
            </div>
        </ExpandedListTab>
    );
}

export default BulkUploadDetailTab;
